import script from "./DeliAdt.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeliAdt.vue?vue&type=script&lang=ts&setup=true"

import "./DeliAdt.vue?vue&type=style&index=0&id=591661a5&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-591661a5"]])

export default __exports__